import Datepicker from 'react-datepicker';

import './datepicker.css';

export const DatePicker = (props: any) => (
  <Datepicker popperPlacement='bottom-end' {...props}></Datepicker>
);
